const useIsMobile = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const  isMobile = /mobile/i.test(userAgent)
    return isMobile;
}
export default useIsMobile